// extracted by mini-css-extract-plugin
export default {"price":"JY-z","onSale":"KY-z","msrpLabelPrice":"LY-z","msrpLabel":"MY-z","originalPrice":"NY-z","percentOff":"OY-z"};